export class CreateFolderRequest {
  parentFolderId: string;
  name: string;
  constructor(parentFolderId: string, name: string) {
    this.parentFolderId = parentFolderId;
    this.name = name;
  }
}


